import PlayerSidebarContainer from "./PlayerSidebarContainer";

export default PlayerSidebarContainer;
